import { render, staticRenderFns } from "./ContactEdit.vue?vue&type=template&id=af3b56f8&scoped=true"
import script from "./ContactEdit.vue?vue&type=script&lang=ts"
export * from "./ContactEdit.vue?vue&type=script&lang=ts"
import style0 from "./ContactEdit.vue?vue&type=style&index=0&id=af3b56f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3b56f8",
  null
  
)

export default component.exports